import { partyQualityMetrics } from "@/mocks/partes";

const statusColors: Record<string, { bar: string; dot: string }> = {
  good: { bar: "bg-primary-500", dot: "bg-primary-500" },
  warning: { bar: "bg-warning-500", dot: "bg-warning-500" },
  danger: { bar: "bg-danger-500", dot: "bg-danger-500" },
};

export default function PartyQualityPanel() {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4">Qualidade do Cadastro de Partes</h3>
      <div className="space-y-4">
        {partyQualityMetrics.map((metric) => {
          const colors = statusColors[metric.status] || statusColors.good;
          return (
            <div key={metric.label} className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${metric.status === "good" ? "bg-primary-50" : metric.status === "warning" ? "bg-warning-50" : "bg-danger-50"}`}>
                <i className={`${metric.icon} w-4 h-4 flex items-center justify-center ${metric.status === "good" ? "text-primary-500" : metric.status === "warning" ? "text-warning-500" : "text-danger-500"}`} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-foreground-600">{metric.label}</span>
                  <span className={`text-xs font-bold font-heading ${metric.status === "good" ? "text-primary-600" : metric.status === "warning" ? "text-warning-600" : "text-danger-600"}`}>
                    {metric.value}
                  </span>
                </div>
                <div className="w-full h-2 bg-background-100 rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full transition-all duration-500 ${colors.bar}`}
                    style={{ width: `${metric.percentage}%` }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}